import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const handleStartFreeClick = () => {
    window.open('https://panel.cafeotomasyonu.com/sign-up', '_blank');
  };

  const handleDemoClick = () => {
    // Demo talep formuna yönlendir
    const element = document.getElementById('demo-request');
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  const handleLiveDemoClick = () => {
    window.open('https://menu.cafeotomasyonu.com/demo-kafe', '_blank');
  };

  return (
    <section id="ana-sayfa" className="relative min-h-screen bg-gradient-to-br from-white via-gray-50 to-red-50 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-20 w-32 h-32 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-40 right-20 w-48 h-48 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-secondary rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-[80vh]">
          {/* Left Content */}
          <div className="space-y-8">
            {/*
              Duyuru rozeti. Eskiden "Türkiye'nin İlk AI Destekli İşletme
              Sistemi" yazıyordu — kanıtlanamayan bir üstünlük iddiası. Yerine
              en yeni GERÇEK yetenek ve onun sayfası.
            */}
            <Link
              to="/ar-menu"
              className="inline-flex items-center space-x-2 bg-gray-900 text-white pl-1.5 pr-4 py-1.5 rounded-full hover:bg-gray-800 transition-colors"
            >
              <span className="px-2 py-0.5 rounded-full bg-primary text-xs font-semibold">YENİ</span>
              <span className="font-inter font-accent-medium text-sm">
                Menüde 3D ve AR — yemek masada görünsün
              </span>
              <Icon name="ArrowRight" size={14} />
            </Link>

            {/* Main Headline */}
            <div className="space-y-4">
              <h1 className="font-poppins font-heading-bold text-4xl md:text-5xl lg:text-6xl text-foreground leading-tight">
                İşletmenizi{' '}
                <span className="text-primary relative">
                  Dijitale
                  <div className="absolute -bottom-2 left-0 w-full h-3 bg-accent/30 -z-10"></div>
                </span>{' '}
                Taşıyın
              </h1>

              <h2 className="font-poppins font-heading-semibold text-xl md:text-2xl text-secondary">
                QR Menü • QR Menü Pro • POS • Online Sipariş • Kurye • Sadakat • Cari & Finans • Yapay Zeka
              </h2>
            </div>

            {/* Description */}
                          <p className="font-open-sans font-body-normal text-lg text-text-secondary leading-relaxed max-w-xl">
                <span className="font-semibold text-green-600">QR Menü tamamen ücretsiz!</span> İnternet kesildiğinde bile duran bir POS, mutfak ekranı, reçete-maliyet takibi ve menü mühendisliği tek panelde.{' '}
                <span className="font-semibold text-primary">7/24 teknik destek</span> ve <span className="font-semibold text-primary">ücretsiz kurulum</span> ile hizmetinizdeyiz.
              </p>

            {/* Key Features */}
            <div className="grid grid-cols-2 gap-4 py-4">
              {[
                { icon: 'QrCode', label: 'QR Menü', note: 'Sürekli ücretsiz', bg: 'bg-green-100', fg: 'text-green-600' },
                { icon: 'CreditCard', label: 'POS Sistemi', note: 'Çevrimdışı çalışır', bg: 'bg-blue-100', fg: 'text-blue-600' },
                { icon: 'ShoppingCart', label: 'Online Sipariş', note: 'Komisyonsuz', bg: 'bg-purple-100', fg: 'text-purple-600' },
                { icon: 'Box', label: '3D/AR Menü', note: 'Uygulamasız', bg: 'bg-amber-100', fg: 'text-amber-700', to: '/ar-menu' },
                { icon: 'Scale', label: 'Reçete & Maliyet', note: 'Otomatik stok düşümü', bg: 'bg-teal-100', fg: 'text-teal-600' },
                { icon: 'Brain', label: 'Yapay Zeka', note: 'Analiz ve öneri', bg: 'bg-red-100', fg: 'text-red-600' }
              ].map((feature) => {
                const body = (
                  <>
                    <div className={`w-8 h-8 ${feature.bg} rounded-lg flex items-center justify-center flex-shrink-0`}>
                      <Icon name={feature.icon} size={16} className={feature.fg} />
                    </div>
                    <div>
                      <p className="font-inter font-accent-semibold text-sm text-foreground">{feature.label}</p>
                      <p className="font-open-sans font-body-normal text-xs text-text-secondary">{feature.note}</p>
                    </div>
                  </>
                );
                return feature.to ? (
                  <Link key={feature.label} to={feature.to} className="flex items-center space-x-3 hover:opacity-80">
                    {body}
                  </Link>
                ) : (
                  <div key={feature.label} className="flex items-center space-x-3">
                    {body}
                  </div>
                );
              })}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                variant="default"
                size="lg"
                onClick={handleStartFreeClick}
                iconName="Eye"
                iconPosition="left"
                className="px-8 py-4 text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Ücretsiz Kullanmaya Başla
              </Button>

              <Button
                variant="secondary"
                size="lg"
                onClick={handleLiveDemoClick}
                iconName="Monitor"
                iconPosition="left"
                className="px-8 py-4 text-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300"
              >
                Canlı Demo
              </Button>

              <Button
                variant="outline"
                size="lg"
                onClick={handleDemoClick}
                iconName="Play"
                iconPosition="left"
                className="px-8 py-4 text-lg border-2 hover:bg-primary hover:text-white transition-all duration-300"
              >
                İletişime Geç
              </Button>
            </div>

            {/*
              Kullanım rehberi — düğme DEĞİL, metin bağlantısı.
              Yanına dördüncü bir düğme konsaydı üç birincil eylemle
              yarışır ve hiçbiri öne çıkmazdı. Rehber satın alma kararının
              önünde duran "bunu kullanabilir miyim" sorusuna cevap veriyor,
              yani gizlenmemeli; ama satın alma eyleminin önüne de geçmemeli.
            */}
            <div className="pt-2">
              <Link
                to="/guide"
                className="inline-flex items-center gap-2 font-open-sans text-text-secondary hover:text-primary transition-colors"
              >
                <Icon name="BookOpen" size={18} />
                <span>
                  Sistem nasıl kullanılıyor? <strong className="font-accent-semibold">Kullanım Rehberi</strong>
                </span>
                <Icon name="ArrowRight" size={16} />
              </Link>
            </div>

            {/*
              Güven satırı. Eskiden "500+ mutlu işletme" ve "%40 gelir artışı"
              yazıyordu; ikisinin de dayanağı yoktu. Yerine ziyaretçinin
              doğrulayabileceği şeyler: indirilebilir kasa uygulaması ve
              ücretsiz modül.
            */}
            <div className="flex flex-wrap items-center gap-x-6 gap-y-3 py-4">
              <Link
                to="/download"
                className="inline-flex items-center gap-2 font-inter font-accent-semibold text-foreground hover:text-primary transition-colors"
              >
                <Icon name="Download" size={18} className="text-primary" />
                Kasa uygulaması: Windows · macOS
              </Link>
              <span className="inline-flex items-center gap-2 font-inter font-accent-medium text-text-secondary">
                <Icon name="WifiOff" size={16} className="text-primary" />
                İnternet kesilse de satış sürer
              </span>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            {/* Main Dashboard Preview */}
            <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden transform rotate-3 hover:rotate-0 transition-transform duration-500">
              <div className="bg-primary p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                      <Icon name="Coffee" size={20} className="text-primary" />
                    </div>
                    <span className="font-poppins font-heading-semibold text-white">
                      Cafe Dashboard
                    </span>
                  </div>
                  <div className="flex space-x-2">
                    <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                    <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                    <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                  </div>
                </div>
              </div>

              <div className="p-6 space-y-4">
                {/* Stats Cards */}
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-green-50 p-4 rounded-lg">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="font-open-sans font-body-normal text-sm text-text-secondary">
                          Günlük Satış
                        </p>
                        <p className="font-poppins font-heading-bold text-xl text-green-600">
                          ₺2,847
                        </p>
                      </div>
                      <Icon name="TrendingUp" size={24} className="text-green-600" />
                    </div>
                  </div>

                  <div className="bg-blue-50 p-4 rounded-lg">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="font-open-sans font-body-normal text-sm text-text-secondary">
                          Aktif Siparişler
                        </p>
                        <p className="font-poppins font-heading-bold text-xl text-blue-600">
                          23
                        </p>
                      </div>
                      <Icon name="Clock" size={24} className="text-blue-600" />
                    </div>
                  </div>
                </div>

                {/* AI Recommendation */}
                <div className="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500">
                  <div className="flex items-center space-x-2 mb-2">
                    <Icon name="Brain" size={16} className="text-purple-600" />
                    <span className="font-poppins font-heading-semibold text-sm text-purple-800">
                      AI Önerisi
                    </span>
                  </div>
                  <p className="font-open-sans font-body-normal text-sm text-purple-700">
                    "Kahve satışlarınızı %25 artırmak için espresso fiyatını %10 düşürün"
                  </p>
                </div>

                {/* Recent Orders */}
                <div className="space-y-3">
                  <h3 className="font-poppins font-heading-semibold text-sm text-foreground">
                    Son Siparişler
                  </h3>
                  {[
                    { name: 'Latte', time: '2 dk önce', status: 'Hazırlanıyor' },
                    { name: 'Cappuccino', time: '5 dk önce', status: 'Tamamlandı' },
                    { name: 'Espresso', time: '8 dk önce', status: 'Tamamlandı' }
                  ].map((order, index) => (
                    <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-inter font-accent-medium text-sm text-foreground">{order.name}</p>
                        <p className="font-open-sans font-body-normal text-xs text-text-secondary">{order.time}</p>
                      </div>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${order.status === 'Tamamlandı' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'
                        }`}>
                        {order.status}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Floating QR Code */}
            <div className="absolute -top-4 -right-4 bg-white rounded-xl shadow-lg p-4 transform rotate-12 hover:rotate-0 transition-transform duration-300">
              <div className="w-16 h-16 bg-gray-200 rounded-lg flex items-center justify-center">
                <Icon name="QrCode" size={24} className="text-gray-600" />
              </div>
              <p className="text-xs text-center mt-2 font-medium">QR Menü</p>
            </div>

            {/* Floating AI Icon */}
            <div className="absolute -bottom-4 -left-4 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl shadow-lg p-4 transform -rotate-12 hover:rotate-0 transition-transform duration-300">
              <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                <Icon name="Brain" size={20} className="text-purple-600" />
              </div>
              <p className="text-xs text-center mt-2 font-medium text-white">AI Destekli</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;